import {range} from "../../services/functions";

export const topBorders = [18,28];
export const bottomBorders = [48,38];

export const teeth = {
    top:[18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28],
    bottom: [48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38],
}
export const teethInSide = 8;
export const teethInSideIndex = 7;

const teethLocations = {
    top:{
        left:[18,17,16,15,14,13,12,11],
        right:[21,22,23,24,25,26,27,28]
    },
    bottom:{
        left:[48,47,46,45,44,43,42,41],
        right:[31,32,33,34,35,36,37,38]
    }
}

export const isoToUniversal = (tooth)=>{
    const position = getToothPosition(tooth);
    const index = teeth[position].findIndex(tooth);
    return position === "top"?  index+1 : 32 - index;
}

const gatherTeethInitialState = [];

Object.keys(teethLocations).forEach((location)=>{
    Object.keys(teethLocations[location]).forEach((subLocation)=>{
        for(const tooth of teethLocations[location][subLocation]){
            gatherTeethInitialState.push(
                {
                    id:tooth,
                    location,
                    subLocation:subLocation,
                    state:"healthy",
                    material:null,
                    faded:false,
                    inBridge:false,
                    isTelescopicCrown:false
                }
            );
        }
    })
})

export const teethInitialState = gatherTeethInitialState;

export const hasGap = (start,end) =>{
    return start < teethInSide && end >= teethInSide;
}


export const getToothIndex = (position,tooth)=>{
    return teeth[position].findIndex(item=>item === tooth);
}

export const getToothPosition = (activeTeeth)=>{

    const tooth  = Array.isArray(activeTeeth)?
        Array.isArray( activeTeeth[0]) ? activeTeeth[0][0] : activeTeeth[0]
        : activeTeeth;
    return teeth.top.find(item=>item===tooth) !== undefined? "top" : "bottom";
}

export const canBridge =  (activeTeeth, teethState)=>{
    const teethInBridge =  getBridgedTeeth(activeTeeth);
    for(const bridgeTooth of teethInBridge){
        const toothState = teethState.find(tooth=>tooth.id === bridgeTooth)?.state;
        const toothStateDisallowed = teethState.find(
            tooth=>
                tooth.id === bridgeTooth &&
                tooth.state === "implant" &&
                !tooth.inBridge);
        if(toothStateDisallowed) return false;
    }
    return true;
}

export const bridgePrice = (currency)=>{
    return abraProds.find(prods=>prods.type === "bridge")[currency];
}

export const getPositionsWithoutBridges = (bridges)=>{
    const bridgedPositions = [];
    bridges.map(bridge=>{
        const position = getToothPosition(bridge.teeth[0]);
        if(!bridgedPositions.includes(position))bridgedPositions.push(position)
    });
    if(bridgedPositions.length === 2) return null;
    else if(bridgedPositions.length) return bridgedPositions[0] === "top"? "bottom" : "top";
    else return "all";
}

export const getFirstAndLastTeethInBridge =(teethInBridge, returnObject)=>{
    const position = getToothPosition(teethInBridge[0]);
    const teethWithIndices = {};
    const teethIndices = teethInBridge.map(tooth=> {
        const index = getToothIndex(position, tooth);
        teethWithIndices[index] =  tooth;
        return index;
    });
    const minIndex = Math.min(...teethIndices);
    const maxIndex = Math.max(...teethIndices);
    if(returnObject){
        return [
            {index:minIndex, tooth: teethWithIndices[minIndex],position},
            {index:maxIndex, tooth: teethWithIndices[maxIndex],position}
        ]
    }
    return [
        teethWithIndices[minIndex],
        teethWithIndices[maxIndex]
    ];
}

export const getBridgedTeeth = (activeTeeth,keepLimits)=>{
    const [f,l] = getFirstAndLastTeethInBridge(activeTeeth,true);
    const teethInPosition = teeth[f.position];
    let inRange = [];
    if(!hasGap(f.index,l.index)){
        const theRange = range(f.index,l.index);
        inRange = theRange.map(toothIndex=>teethInPosition[toothIndex])
        if(!keepLimits){
            inRange.pop();
            inRange.shift();
        }
    }else{
        if(keepLimits) inRange.push(f.tooth);
        if(f.index<teethInSideIndex){
            let x = f.index+1;
            while(x<=teethInSideIndex){
                inRange.push(teethInPosition[x]);
                x++;
            }
        }
        const startOfSide = teethInSideIndex+1;
        if(l.index > startOfSide){
            let y = startOfSide;
            while(y<l.index){
                inRange.push(teethInPosition[y]);
                y++;
            }
        }
        if(keepLimits) inRange.push(l.tooth);
    }
    return inRange;
}

